<template lang="pug">
b-modal#editFreeCredit(
  ref="editFreeCredit"
  :title="$t('ui.combine.edit_free_credit')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.promo_type')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promo_type"
        type="text"
        v-model.trim.lazy="promo_type"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.rollover')").mb-0
      DebounceInput(
        size="sm"
        ref="rollover"
        type="text"
        :dirty="$v.rollover.$dirty"
        :error="$v.rollover.$error"
        v-model.trim.lazy="$v.rollover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
    b-form-group(:label="$t('ui.criteria')").mb-0
      VipCriteriaList(
        ref="criteria"
        size="sm"
        required
        type="array"
        :dirty="$v.criteria.$dirty"
        :error="$v.criteria.$error"
        v-model.trim.lazy="$v.criteria.$model"
        :disabled="loading"
        :hideOpt="hideOpt"
      )
      ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
    b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
      DebounceInput(
        size="sm"
        ref="max_withdraw_amount"
        required
        type="text"
        :dirty="$v.max_withdraw_amount.$dirty"
        :error="$v.max_withdraw_amount.$error"
        v-model.trim.lazy="$v.max_withdraw_amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, decimal, integer } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      rollover: "",
      criteria: "",
      max_withdraw_amount: "",
      promo_type: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      hideOpt: ['DEPOSIT']
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  validations: {
    rollover: {
      required,
      integer
    },
    criteria: {
      required
    },
    max_withdraw_amount: {
      required,
      decimal
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionFreeEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promo_type: this.item.promo_type,
          rollover: this.rollover,
          criteria: this.criteria,
          max_withdraw_amount: this.max_withdraw_amount,
          withhold_bonus: 0,
          withhold_amount: 0
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editFreeCredit.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_free_credit", this.feedback.status);
                  this.$refs.editFreeCredit.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.promo_type = this.item.promo_type;
      this.rollover = this.item.rollover;
      this.criteria = this.item.criteria;
      this.max_withdraw_amount = this.item.max_withdraw_amount;
    }
  },
};
</script>
